// components/organism/PopUp/ReusablePopup.tsx

import React from 'react';
import { Typography } from '@mui/material';
import closeIcon from '@/assets/icons/close.svg';
import { POPUP_TYPES } from '@/utils/constants';

interface ReusablePopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  header?: string;
  typeClassName?: string;
  showFooter?: boolean;
  type?: POPUP_TYPES;
  onFooterClick?: () => void;
  isPaginationShown? : boolean;
}

const ReusablePopup: React.FC<ReusablePopupProps> = ({
  isOpen,
  onClose,
  children,
  header,
  typeClassName = '',
  type = POPUP_TYPES.CUSTOMER_DETAILS,
  showFooter = true,
  onFooterClick,
  isPaginationShown = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className={`${typeClassName} ${typeClassName.includes('contract-list-popup') ? (isPaginationShown ? 'popup-pagination' : 'popup-no-pagination') : ''}`}>
        <div className={`popup-container ${type}`}>
          <div className="popup-header_wrap">
            <img src={closeIcon} className="popup-close" onClick={onClose} />
            {header && <Typography className="title">{header}</Typography>}
          </div>
          {children}
        </div>

        {showFooter && (
          <div className="popup-btn_wrap">
            {type !== POPUP_TYPES.CUSTOMER_DETAILS && <div />}
            {onFooterClick && (
              <Typography className="link" onClick={onFooterClick}>
                See all contracts
              </Typography>
            )}
            <button className="popup-close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReusablePopup;
